import { apiRequest } from "./ApiUtility";

export async function getDocumentNotes(authContext, documentId, documentType) {
  const url = `/api/documentnote/getall/${documentType}/${documentId}`;
  return await apiRequest("get", url, authContext);
}
export async function addDocumentNote(authContext, note) {
  const url = `/api/documentnote`;
  return await apiRequest("post", url, authContext, note);
}
export async function updateDocumentNote(authContext, note) {
  const url = `/api/documentnote`;
  return await apiRequest("put", url, authContext, note);
}
export async function deleteDocumentNote(authContext, noteId) {
  const url = `/api/documentnote/${noteId}`;
  return await apiRequest("delete", url, authContext);
}